import request from '@/common/request';

// 获取词典
// https://km.qutoutiao.net/pages/viewpage.action?pageId=176490614
export function getCommonDict(params) {
  return request({ url: '/common/dict', method: 'get', params });
}